import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";
import { SubscriptionTier } from "./contracts/SubscriptionTier";

interface PlanFeatureListProps {
  tier?: SubscriptionTier;
}

/** The value props shown under the plan offer. Materials are on every plan; the Verein tier adds the absence features. */
const PlanFeatureList = ({ tier = SubscriptionTier.Solo }: PlanFeatureListProps) => {
  const { t } = useTranslation();

  const features = [
    t("subscription.page.plans.featureEverything"),
    t("subscription.page.plans.featureMembers"),
    t("subscription.page.plans.featureBilling"),
    t("subscription.page.plans.featureMaterials"),
    ...(tier === SubscriptionTier.Verein
      ? [t("subscription.page.plans.featurePortalCommunity")]
      : []),
    t("subscription.page.plans.featureData"),
    t("subscription.page.plans.featureCancel"),
  ];

  return (
    <ul className="flex flex-col gap-2.5">
      {features.map((feature) => (
        <li key={feature} className="flex items-start gap-2.5">
          <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400">
            <Check size={13} strokeWidth={3} />
          </span>
          <span className="text-sm text-grey-30 dark:text-grey-80">{feature}</span>
        </li>
      ))}
    </ul>
  );
};

export default PlanFeatureList;
